import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingIndicator } from "../CommonUIComponents/LoadingIndicator/LoadingIndicator";
import { Button } from "../CommonUIComponents/Button/Button";
import { useI18n } from "../../hooks/useI18n";
import {
  fetchConsentStatus,
  selectIsConsentValid,
} from "../../store/slices/consentSlice";
import { ConsentModal } from "./ConsentModal";
import "./ConsentGate.scss";

export function ConsentGate({ children }) {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.consent.status);
  const error = useSelector((state) => state.consent.error);
  const isConsentValid = useSelector(selectIsConsentValid);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchConsentStatus());
    }
  }, [status, dispatch]);

  if (status === "idle" || status === "loading") {
    return <LoadingIndicator show={true} fullscreen={true} />;
  }

  if (status === "error" && !isConsentValid) {
    return (
      <div className="consent-gate-error">
        <p>{t("consent_loadingError")}</p>
        {error && typeof error === "string" && (
          <p className="consent-gate-error-detail">{error}</p>
        )}
        <Button
          variant="primary"
          onClick={() => dispatch(fetchConsentStatus())}
        >
          {t("consent_retry")}
        </Button>
      </div>
    );
  }

  if (!isConsentValid) {
    return <ConsentModal />;
  }

  return children;
}

export default ConsentGate;
